import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
} from '@angular/core';
import { TelXLAvatarComponent } from '@dxp/elements';
import { ICustomerDetails } from '@dxp/core/models';
import { EndCustomerStateService } from '../../services/end-customer.state.service';

@Component({
    selector: 'end-customer-details-initials',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TelXLAvatarComponent],
    templateUrl: './customer-details-initials.component.html',
    styleUrl: './customer-details-initials.component.scss',
})
export class EndCustomerDetailsInitialsComponent {
    readonly #endCustomerStateService = inject(EndCustomerStateService);

    customer = computed<ICustomerDetails | undefined>(() =>
        this.#endCustomerStateService.selectedEndCustomer(),
    );

    name = computed<string>(() => {
        const name = this.customer()?.name;
        return name && name.length > 0 ? name : 'Unknown Customer';
    });
}
